module.exports = __webpack_public_path__ + "img/iaqfaz-logo.f57fb0af.png";